import { SET_TICKET_PARAMS, TicketParamsReducer } from './types';

export const ticketParamsReducer: TicketParamsReducer = (_, action) => {
  switch (action.type) {
    case SET_TICKET_PARAMS:
      return action.payload;
  }
};
